/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Externalkey1Inputs */

const en_entity_externalkey1 = /** @type {(inputs: Entity_Externalkey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Key`)
};

const de_entity_externalkey1 = /** @type {(inputs: Entity_Externalkey1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externer Schlüssel`)
};

/**
* | output |
* | --- |
* | "External Key" |
*
* @param {Entity_Externalkey1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_externalkey1 = /** @type {((inputs?: Entity_Externalkey1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Externalkey1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_externalkey1(inputs)
	return de_entity_externalkey1(inputs)
});
export { entity_externalkey1 as "entity_externalKey" }